import React from 'react';
import OmatechDigitalPreview from './OmatechDigitalPreview';

function App() {
  return (
    <div className="App">
      <OmatechDigitalPreview />
    </div>
  );
}

export default App;


















